import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SevenFever_ResponsivePIXIApp } from "../SevenFever/game_ResponsivePIXIApp";

export class SevenFeverLink_ResponsivePIXIApp extends SevenFever_ResponsivePIXIApp {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SevenFeverLink");
    }

}